module.exports = __webpack_public_path__ + "img/moab-1-mobile.929ee08c.jpg";